import styled from "styled-components";
import { addIcon, hoverStyle, focusStyle, subText, tertiarySmall, ellipsis, activeStyle } from "@mixins";
export var Table = styled.table.withConfig({
  displayName: "graphAxisTablestyles__Table",
  componentId: "sc-1etjoc2-0"
})(["", ""], function (_ref) {
  var theme = _ref.theme;
  return "\n    border-collapse: collapse;\n    width: 400px;\n    height: fit-content;\n    margin-bottom: 20px\n\n    @media (max-width: ".concat(theme.breakpoints[2], "){\n      width: 100%;\n    }\n");
});
export var SortableColumn = styled.button.withConfig({
  displayName: "graphAxisTablestyles__SortableColumn",
  componentId: "sc-1etjoc2-1"
})(["&:after{position:absolute;right:5px;bottom:5px;line-height:2.4rem;", "}", ""], function (_ref2) {
  var theme = _ref2.theme,
    icon = _ref2.icon;
  return addIcon(theme, icon);
}, function (_ref3) {
  var theme = _ref3.theme,
    active = _ref3.active,
    disabled = _ref3.disabled;
  return "\n    padding: 0 35px 0 5px;\n    background: none;\n    position: relative;\n    text-align: left;\n    width: 100%;\n    height: 34px;\n    transition: all .3s;\n\n    &:hover{ ".concat(!disabled && hoverStyle(theme) || "", " }\n    &:focus{ ").concat(focusStyle(theme), " }\n    ").concat(active ? activeStyle(theme) : "", "\n  ");
});
export var Th = styled.th.withConfig({
  displayName: "graphAxisTablestyles__Th",
  componentId: "sc-1etjoc2-2"
})(["", ""], function (_ref4) {
  var theme = _ref4.theme;
  return "\n    ".concat(tertiarySmall(theme), "\n    text-align: left;\n\n    &:first-child{ width: 50px; }\n    &:last-child{\n      width: 90px;\n      p { text-align: center; }\n    }\n  ");
});
export var Td = styled.td.withConfig({
  displayName: "graphAxisTablestyles__Td",
  componentId: "sc-1etjoc2-3"
})(["padding:0;max-width:0;&:last-child{padding:0;}"]);
export var Tr = styled.tr.withConfig({
  displayName: "graphAxisTablestyles__Tr",
  componentId: "sc-1etjoc2-4"
})(["", ""], function (_ref5) {
  var theme = _ref5.theme;
  return "\n    height: 34px;\n\n    &:not(:first-child){ box-shadow: 0 -1px 0 0px ".concat(theme.colors.G4, "1a; }\n    &:last-child{ box-shadow: 0 -1px 0 0px ").concat(theme.colors.G4, "1a, 0 1px 0 0 ").concat(theme.colors.G4, "1a; }\n    ");
});
export var Remove = styled.button.withConfig({
  displayName: "graphAxisTablestyles__Remove",
  componentId: "sc-1etjoc2-5"
})(["&:before{color:", ";", "}", ""], function (_ref6) {
  var theme = _ref6.theme;
  return theme.colors.G1;
}, function (_ref7) {
  var theme = _ref7.theme,
    disableInteraction = _ref7.disableInteraction;
  return !disableInteraction ? addIcon(theme, "cross_xs", "auto") : "";
}, function (_ref8) {
  var theme = _ref8.theme,
    color = _ref8.color;
  return "\n    border: none;\n    outline: none;\n    width: 26px;\n    height: 26px;\n    border-radius: 50%;\n    padding: 0;\n    margin: auto;\n    display: block;\n    background: ".concat(color, ";\n    transition: all .3s;\n\n    &:focus { ").concat(focusStyle(theme), " }\n    &:hover {\n      ").concat(hoverStyle(theme), "\n      &:before { color: ").concat(theme.colors.P1, "; }\n    }\n    &.hidden-styles{\n      position: relative;\n      opacity: 1;\n      z-index: auto;\n      width: 26px;\n      height: 26px;\n      &:before{\n        content: '';\n      }\n    }\n    ");
});
export var DrillButton = styled.button.withConfig({
  displayName: "graphAxisTablestyles__DrillButton",
  componentId: "sc-1etjoc2-6"
})(["&:after{position:absolute;right:15px;", "}", ""], function (_ref9) {
  var theme = _ref9.theme,
    disabled = _ref9.disabled;
  return !disabled ? addIcon(theme, "expandRight_xs") : "";
}, function (_ref10) {
  var theme = _ref10.theme,
    disabled = _ref10.disabled;
  return "\n    ".concat(subText(theme), "\n    ").concat(ellipsis, "\n    color: ").concat(theme.colors.G4, ";\n    position: relative;\n    width: 100%;\n    height: 33px;\n    padding-right: 30px;\n    text-align: left;\n    background: none;\n    transition: all .3s;\n\n    ").concat(!disabled ? "\n      &:focus { ".concat(focusStyle(theme), " }\n      &:hover { ").concat(hoverStyle(theme), " }\n    ") : "");
});
export var Value = styled.p.withConfig({
  displayName: "graphAxisTablestyles__Value",
  componentId: "sc-1etjoc2-7"
})(["", ""], function (_ref11) {
  var theme = _ref11.theme,
    values = _ref11.values;
  return "\n    ".concat(values === 2 ? tertiarySmall(theme) : subText(theme), "\n    margin: auto;\n    width: 100%;\n    height: ").concat(values === 2 ? "50%" : "100%", ";\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    &:nth-child(2){\n      font-family: ").concat(theme.fonts.robotoRegular, ";\n      background: ").concat(theme.colors.P3, ";\n      color: ").concat(theme.colors.G1, ";\n      margin: 0;\n      padding: 1px 0;\n    }");
});